import axios from "axios";
import API_URL from "../config";

const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// 1️⃣ Ajouter automatiquement le token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("access_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// 2️⃣ Rafraîchir automatiquement si 401
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      try {
        const refresh = localStorage.getItem("refresh_token");

        const res = await axios.post(`${API_URL}/token/refresh/`, {
          refresh,
        });

        localStorage.setItem("access_token", res.data.access);

        error.config.headers.Authorization = `Bearer ${res.data.access}`;

        return api(error.config);
      } catch (err) {
        localStorage.clear();
        window.location.href = "/login";
      }
    }

    return Promise.reject(error);
  },
);

export default api;
